
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const LocationsContent = () => {
  return (
    <>
      {/* AI-Powered Blog Section */}
      <section id="ai-content" className="bg-gradient-to-r from-blue-100 to-blue-50 p-8 rounded-lg mt-12">
        <h2 className="text-2xl font-bold mb-4">Explore Roofing Insights from Our AI-Powered Blog</h2>
        <p className="text-lg mb-6">
          Get local guides, seasonal tips, and expert advice—all generated and curated by AI with 
          real-time updates for Rocky Mount, NC and surrounding areas.
        </p>
        <Link to="/blog">
          <Button className="flex items-center">
            Read the Blog <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="bg-gradient-to-r from-gray-100 to-gray-50 p-8 rounded-lg mt-8">
        <h2 className="text-2xl font-bold mb-4">View Our Project Gallery</h2>
        <p className="text-lg mb-6">
          See real installations and repairs across Eastern NC—before & after images updated regularly.
        </p>
        <Link to="/gallery">
          <Button variant="outline" className="flex items-center">
            View Projects <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </section>
    </>
  );
};

export default LocationsContent;
